import request from './request'
import md5 from 'md5'
export function login(form) {
	const params = {
		password:  md5(form.password),
    	userName: form.userName,
	}
	return request({
		url: '/app/login',
		method: 'post',
		data: params
	})
}

export function onLogin(form) {
	return request({
		url: '/app/login',
		method: 'post',
		data: form
	})
}
export function planMonthByDay(params) {
	return request({
		url: '/app/ytsh/planMonthByDay',
		method: 'post',
		data: params
	})
}
export function getShipPlan(params) {
	return request({
		url: '/app/ytsh/getShipPlan',
		method: 'post',
		data: params
	})
}
// 液体散货作业计划----完成
export function queryYtshzyjhb(params) {
	return request({
		url: '/app/easy/queryYtshzyjhb',
		method: 'post',
		data: params
	})
}
export function queryYtshThroughputPlan(params) {
	return request({
		url: '/app/easy/queryYtshThroughputPlan',
		method: 'post',
		data: params
	})
}
export function queryCompany(params) {
	return request({
		url: '/app/easy/queryCompany',
		method: 'post',
		data: params
	})
}
// 码头概览-货种占比
export function queryYtshhznlj(params) {
	return request({
		url: '/app/easy/queryYtshhznlj',
		method: 'post',
		data: params
	})
}
// 日报表吞吐量完成
export function queryYtshrbbttl(params) {
	return request({
		url: '/app/easy/queryYtshrbbttl',
		method: 'post',
		data: params
	})
}
// 市报表日提取月累--完成
export function queryYtshLevShipWorkYL(params) {
	return request({
		url: '/app/easy/queryYtshLevShipWorkYL',
		method: 'post',
		data: params
	})
}
// 日报表分货种---完成
export function queryYtshRbbFhz(params) {
	return request({
		url: '/app/easy/queryYtshRbbFhz',
		method: 'post',
		data: params
	})
}
/* 液体散货-油罐 */
export function queryYtshyg(params) {
	return request({
		url: '/app/easy/queryYtshyg',
		method: 'post',
		data: params
	})
}


export function queryDevice(params) {
	return request({
		url: '/app/ytsh/queryDevice',
		method: 'post',
		data: params
	})
}
export function statisticsPileStorageInfo(params) {
	return request({
		url: '/app/gsh/statisticsPileStorageInfo',
		method: 'post',
		data: params
	})
}
export function queryShipPlan(params) {
	return request({
		url: '/app/gsh/queryShipPlan',
		method: 'post',
		data: params
	})
}

export function shipOverview(params) {
	return request({
		url: '/app/qg3d/shipOverview',
		method: 'post',
		data: params
	})
}

export function weather(params) {
	return request({
		url: '/app/weather',
		method: 'post',
		data: params
	})
}

export function berthShipDetail(params) {
	return request({
		url: '/app/qg3d/berthShipDetail',
		method: 'post',
		data: params
	})
}

export function queryYtshygArea(params) {
	return request({
		url: '/app/easy/queryYtshygArea',
		method: 'post',
		data: params
	})
}

export function getCarWorkload(params) {
	return request({
		url: '/app/qg3d/getCarWorkload',
		method: 'post',
		data: params
	})
}

export function getTrainWorkload(params) {
	return request({
		url: '/app/qg3d/getTrainWorkload',
		method: 'post',
		data: params
	})
}

export function getShipWorkload(params) {
	return request({
		url: '/app/qg3d/getShipWorkload',
		method: 'post',
		data: params
	})
}

// 船舱作业量
export function queryShipWorkload(params) {
	return request({
		url: '/app/qg3d/GetBerthShipWorkingInfo',
		method: 'post',
		data: params
	})
}

//干散货吞吐量
export function querySzhTtlYear(params) {
	return request({
		url: '/app/gsh/querySzhTtlYear',
		method: 'post',
		data: params
	})
}

export function querySzhTtlMonth(params) {
	return request({
		url: '/app/gsh/querySzhTtlMonth',
		method: 'post',
		data: params
	})
}

export function querySzhTtlDay(params) {
	return request({
		url: '/app/gsh/querySzhTtlDay',
		method: 'post',
		data: params
	})
}

export function queryAnemometer(params) {
	return request({
		url: '/app/easy/queryAnemometer',
		method: 'post',
		data: params
	})
}

export function queryShipOn(params) {
	return request({
		url: '/app/zdhmt/queryShipOn',
		method: 'post',
		data: params
	})
}

export function queryShipEstimated(params) {
	return request({
		url: '/app/zdhmt/queryShipEstimated',
		method: 'post',
		data: params
	})
}

export function queryContainerById(params) {
	return request({
		url: '/app/zdhmt/queryContainerById',
		method: 'post',
		data: params
	})
}

export function queryContainerNum(params) {
	return request({
		url: '/app/zdhmt/queryContainerNum',
		method: 'post',
		data: params
	})
}

export function queryYardUtilizationRate(params) {
	return request({
		url: '/app/zdhmt/queryYardUtilizationRate',
		method: 'post',
		data: params
	})
}

export function queryCardIn(params) {
	return request({
		url: '/app/zdhmt/queryCardIn ',
		method: 'post',
		data: params
	})
}

export function queryCardOut(params) {
	return request({
		url: '/app/zdhmt/queryCardOut ',
		method: 'post',
		data: params
	})
}

export function queryContainerTotal(params) {
	return request({
		url: '/app/zdhmt/queryContainerTotal ',
		method: 'post',
		data: params
	})
}

export function queryByType(params) {
	return request({
		url: '/app/qg3d/queryByType',
		method: 'post',
		data: params
	})
}

export function queryAGV(params) {
	return request({
		url: '/app/zdhmt/queryAGV',
		method: 'post',
		data: params
	})
}

export function queryASC(params) {
	return request({
		url: '/app/zdhmt/queryASC',
		method: 'post',
		data: params
	})
}

export function querySTS(params) {
	return request({
		url: '/app/zdhmt/querySTS',
		method: 'post',
		data: params
	})
}

export function queryJzxttl(params) {
	return request({
		url: '/app/zdhmt/queryJzxttl',
		method: 'post',
		data: params
	})
}

export function queryYtshjk(params) {
	return request({
		// url: '/app/camera/list',
		url: '/app/easy/queryYtshjk',
		method: 'post',
		data: params
	})
}

// 根据code获取视频流
export function getVideoStream(params) {
	return request({
		url: '/app/camera/getUrl',
		method: 'post',
		data: params
	})
}

export function queryYtshgd(params) {
	return request({
		url: '/app/easy/queryYtshgd',
		method: 'post',
		data: params
	})
}

export function queryYtshsyb(params) {
	return request({
		url: '/app/easy/queryYtshsyb',
		method: 'post',
		data: params
	})
}

export function getPilesTotal(params) {
	return request({
		url: '/app/qg3d/getPilesTotal',
		method: 'post',
		data: params
	})
}

export function queryYearTtl(params) {
	return request({
		url: '/app/ytsh/queryYearTtl',
		method: 'post',
		data: params
	})
}

export function queryMonthTtl(params) {
	return request({
		url: '/app/ytsh/queryMonthTtl',
		method: 'post',
		data: params
	})
}


export function weatherSensor(params) {
	return request({
		url: '/app/weatherSensor',
		method: 'post',
		data: params
	})
}

export function groupDeviceNum(params) {
	return request({
		url: '/app/zdhmt/groupDeviceNum',
		method: 'post',
		data: params
	})
}


export function groupShip(params) {
	return request({
		url: '/app/zdhmt/groupShip',
		method: 'post',
		data: params
	})
}

export function queryNetPressureAlarmData(params) {
	return request({
		url: '/app/easy/queryNetPressureAlarmData',
		method: 'post',
		data: params
	})
}

export function queryNetTempertureAlarmData(params) {
	return request({
		url: '/app/easy/queryNetTempertureAlarmData',
		method: 'post',
		data: params
	})
}

export function queryGwgxAlarmData(params) {
	return request({
		url: '/app/easy/queryGwgxAlarmData',
		method: 'post',
		data: params
	})
}
export function queryDataAlarmInformation(params) {
	return request({
		url: '/app/easy/queryDataAlarmInformation',
		method: 'post',
		data: params
	})
}

// 干散货禁装车
export function queryGshjzc(params) {
	return request({
		url: '/app/qg3d/getGdList',
		method: 'post',
		data: params
	})
}

// 股道明细
export function queryGdDetail(params) {
	return request({
		url: '/app/qg3d/listSort',
		method: 'post',
		data: params
	})
}

// 船舶动态
export function queryShipDynamic(params) {
	return request({
		url: '/app/ytsh/getShipStatus',
		method: 'post',
		data: params
	})
}

// 卸货动态
export function queryXhDynamic(params) {
	return request({
		url: '/app/ytsh/getUnloadStatus',
		method: 'post',
		data: params
	})
}

// 车的状态
export function queryCarStatus(params) {
	return request({
		url: 'app/qg3d/queryCarState',
		method: 'post',
		data: params
	})
}






export function getRandomNumber(min = 1, max = 100, decimalPlaces = 2) {
	let range = max - min;
	return ((Math.random() * range) + min).toFixed(decimalPlaces);
}

// 潮汐cx

export function queryTide(params) {
	return request({
		url: '/app/cx',
		method: 'post',
		data: params
	})
}

// 潮汐cx_level
export function queryTideLevel(params) {
	return request({
		url: '/app/cxLevel',
		method: 'post',
		data: params
	})
}

// 获取液位和温度
export function getWaterTemp(params) {
	return request({
		url: 'app/ytsh/getYg',
		method: 'post',
		data: params
	})
}
